var _linearGradient, _path, _path2, _linearGradient2, _path3, _linearGradient3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCampfire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2J1LH0~lKNWrWAWFkXx8a",
    x1: 8,
    x2: 37,
    y1: 39,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c26715"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.508,
    stopColor: "#b85515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ad3f16"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d2J1LH0~lKNWrWAWFkXx8a)",
    d: "M35.002,44c0.903,0,1.723-0.617,1.942-1.534c0.258-1.074-0.403-2.154-1.478-2.412l-25-6 c-1.08-0.255-2.154,0.405-2.411,1.478c-0.258,1.074,0.403,2.154,1.478,2.412l25,6C34.69,43.982,34.848,44,35.002,44z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#d6742d",
    d: "M12.998,44c-0.903,0-1.723-0.617-1.942-1.534c-0.258-1.074,0.403-2.154,1.478-2.412l25-6 c1.08-0.255,2.154,0.405,2.411,1.478c0.258,1.074-0.403,2.154-1.478,2.412l-25,6C13.31,43.982,13.153,44,12.998,44z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2J1LH0~lKNWrWAWFkXx8b",
    x1: 19.955,
    x2: 26.294,
    y1: 3.685,
    y2: 38.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f44f5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#ee3d4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e52030"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d2J1LH0~lKNWrWAWFkXx8b)",
    d: "M21.422,4.533C21.408,4.484,21.4,4.397,21.4,4.333c0-0.479,0.388-0.867,0.867-0.867 c0.204,0,0.346,0.076,0.402,0.098c1.06,0.414,8.338,3.846,6.655,13.769c2.444-1.473,1.57-4.333,2.37-4.333 c0.3,0,0.423,0.112,0.607,0.375C34.975,17.191,37,21.742,37,26c0,7.18-5.82,13-13,13c-7.895,0-13-6.65-13-13 C11,15.438,23.448,13.488,21.422,4.533z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d2J1LH0~lKNWrWAWFkXx8c",
    x1: 21.141,
    x2: 26.507,
    y1: 14.27,
    y2: 43.574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fed100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e36001"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d2J1LH0~lKNWrWAWFkXx8c)",
    d: "M23.666,16.188c0,0-0.221-0.188-0.541-0.188c-0.483,0-0.875,0.392-0.875,0.875 c0.875,5.25-5.25,7-5.25,13.125c0,3.866,3.134,7,7,7s7-3.134,7-7C31,25.012,26.607,18.355,23.666,16.188z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfire);
export default __webpack_public_path__ + "static/media/campfire.1cd73f5c6262c1575122f3400d67cd2f.svg";
export { ForwardRef as ReactComponent };